import React, { useEffect, useRef } from 'react';
import { XIcon } from 'lucide-react';
type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
};
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  const modalRef = useRef<HTMLDivElement>(null);
  // Close modal when clicking outside
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
        onClose();
      }
    }
    // Close modal when pressing Escape key
    function handleEscKey(event: KeyboardEvent) {
      if (event.key === 'Escape') {
        onClose();
      }
    }
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscKey);
      // Prevent scrolling when modal is open
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscKey);
      document.body.style.overflow = 'auto';
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4" data-id="element-215">
      <div ref={modalRef} className="bg-white rounded-lg shadow-xl w-full max-w-md max-h-[90vh] overflow-auto" role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-216">
        <div className="flex items-center justify-between border-b border-amber-100 p-4" data-id="element-217">
          <h2 id="modal-title" className="text-xl font-bold text-amber-800" data-id="element-218">
            {title}
          </h2>
          <button onClick={onClose} className="text-amber-500 hover:text-amber-700 transition" aria-label="Cerrar" data-id="element-219">
            <XIcon className="h-5 w-5" data-id="element-220" />
          </button>
        </div>
        <div className="p-6" data-id="element-221">{children}</div>
      </div>
    </div>;
}